import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import TopActionBar from '../../../uikit/top_actionbar';
import Button from '../../../uikit/button';
import { API_ASSET_BASE_URL } from '../../../apiConstant';
import { getDateModifiedFormat } from '../../../utils/commonUtils';
import DisplayFiles from '../../project/components/pages/labour-payments/DisplayFiles';
import { useS3FilesByType } from '../../../utils/hooks/useS3FilesByType';
import { FILE_TYPES } from '../../../utils/constants';
import DragDrop2 from '../../../uikit/drag_and_drop/DargDrop2';

export default function InsuranceView() {
  const { id: insuranceID } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: insurance, isLoading: isInsuranceLoading } = useQuery({
    queryKey: ['insurance', insuranceID],
    queryFn: async () => {
      const res = await axios.get(`${API_ASSET_BASE_URL}/api/insurances/${insuranceID}`);
      return res.data?.data || null;
    },
    enabled: !!insuranceID,
  });

  const { data: files = [] } = useS3FilesByType({
    type: FILE_TYPES.INSURANCE_DOCUMENTS,
    id: insuranceID,
    enabled: !!insuranceID,
  });

  const goBack = () => {
    navigate(-1);
  };

  const formatValue = (value) => value || '-';

  if (isInsuranceLoading) {
    return <div className="p-8 text-center">Loading insurance details...</div>;
  }

  if (!insurance) {
    return <div className="p-8 text-center">Insurance not found.</div>;
  }

  const rows = [
    { label: 'Insurance Provider', value: formatValue(insurance.providerName) },
    { label: 'Insurance Name', value: formatValue(insurance.insuranceName) },
    { label: 'Policy Name', value: formatValue(insurance.policyName) },
    { label: 'Insurance Start Date', value: getDateModifiedFormat(insurance.startDate) },
    { label: 'Insurance End Date', value: getDateModifiedFormat(insurance.endDate) },
    { label: 'Serial Number', value: formatValue(insurance.policyNumber) },
    { label: 'Remarks (Optional)', value: formatValue(insurance.remarks) },
    { label: 'Details', value: formatValue(insurance.details) },
    // { label: 'Uploaded Asset Image', value: formatValue(insurance.documentUrl) },
  ];

  return (
    <>
      <TopActionBar
        leftContent={
          <div className="flex items-center text-white gap-4">
            <Button
              containerClass="md:block hidden"
              onClick={goBack}
              startIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="6"
                  height="11"
                  fill="none"
                >
                  <path
                    d="M5 10L1 5.5L5 1"
                    stroke="#FFCC00"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              variant="secondaryContained"
            />
            <h2 className="font-semibold text-lg">View Insurance</h2>
          </div>
        }
      />

      <div className="bg-gray-50 rounded-lg">
        <div className="bg-white rounded-lg shadow-sm p-6 w-full max-w-5xl mx-auto">
          <h3 className="text-[#A86808] text-lg font-semibold mb-4">Insurance Details</h3>

          <div className="bg-[#151C2E] rounded-lg overflow-hidden">
            {rows.map((row, idx) => (
              <div
                key={row.label}
                className={`flex items-center px-6 py-4 ${
                  idx !== rows.length - 1 ? 'border-b border-white/5' : ''
                }`}
              >
                <div className="w-1/3 text-white text-sm font-medium">{row.label}</div>
                <div className="w-2/3 text-[#f08c00] text-sm font-medium">{row.value}</div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mt-4" >
            <div>
              <label className="block text-base font-bold text-[#A86808] mb-2">Upload Image</label>

              <DragDrop2
                // ref={uploadRef}
                type={FILE_TYPES.INSURANCE_DOCUMENTS}
                id={insuranceID}
                onUpload={() => {
                  queryClient.invalidateQueries({
                    queryKey: ['s3-files', FILE_TYPES.INSURANCE_DOCUMENTS, insuranceID],
                  });
                }}
                variant="small"
                subtitle="PDF, Images and Documents"
              />

            </div>

            {/* Right Column */}
            <div>
              <label className="block text-base font-bold text-[#A86808] mb-2">Uploaded Files</label>
              <DisplayFiles
                files={files}
                onDelete={() => {
                  queryClient.invalidateQueries({
                    queryKey: ['s3-files', FILE_TYPES.INSURANCE_DOCUMENTS, insuranceID],
                  });
                }}
                enableDelete={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}